/* eslint-disable */
import { permissionsMessages } from '@ringcentral-integration/commons/enums/permissionsMessages';
export default {
  [permissionsMessages.invalidTier]:
    'Sua edição não oferece suporte à integração com {application}. Entre em contato com o representante da conta para atualizar a edição do {brand}.',
  [permissionsMessages.insufficientPrivilege]:
    'Privilégios insuficientes. Entre em contato com o representante da conta para fazer uma atualização.',
} as const;

// @key: @#@"[permissionsMessages.invalidTier]"@#@ @source: @#@"Your edition does not support {application} integration. Please contact your account representative to upgrade your {brand} edition."@#@
// @key: @#@"[permissionsMessages.insufficientPrivilege]"@#@ @source: @#@"Insufficient privilege. Please contact your account representative for an upgrade."@#@
